import React, { useMemo } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import { NewTab } from '@siftscience/focus-components/icons'
import { Text } from '@siftscience/focus-components/text'
import { Tooltip } from '@siftscience/focus-components/tooltip'
import { useLocation } from 'react-router-dom'
import { startCase } from 'lodash'
import {
  ACTIVE_TEMPLATE_PARAM_NAME,
  useTemplateContext
} from '../../../context/template-context'

const TOOLTIP_CONTENT = 'Save current template to edit a new one'

interface StylesProps {
  selected: boolean
  isDirty: boolean
}

const useStyles = makeStyles<Theme, StylesProps>(() => ({
  subtemplate: {
    width: 'fit-content',
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: ({ isDirty, selected }) =>
      selected ? '#CCCCCC' : isDirty ? '#FFFFFF' : '#F7F7F7',
    border: ({ isDirty }) =>
      isDirty ? '1px solid #EBEBEB' : '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '10px 16px',
    cursor: ({ isDirty }) => (isDirty ? 'not-allowed' : 'pointer'),
    margin: '5px 0',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,

    '& svg': {
      width: '16px',
      height: '16px'
    }
  }
}))

const StComponent = ({ node, selected, editor }) => {
  const { updatedTemplateContent: { isDirty } = {}, templateList } =
    useTemplateContext()
  const location = useLocation()
  const { stName } = node.attrs
  const classes = useStyles({
    selected,
    isDirty
  })

  const url = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    const templateId = templateList?.find(
      template => template?.name === stName
    )?.templateId
    searchParams.set(ACTIVE_TEMPLATE_PARAM_NAME, `${templateId}`)
    const newSearchString = searchParams.toString()
    return `${location.pathname}?${newSearchString}`
  }, [location, stName])

  return (
    <NodeViewWrapper
      className={`st-node ${selected ? 'Tiptap-selected' : ''}`}
      as="div"
      data-drag-handle={true}
    >
      {isDirty ? (
        <Tooltip content={TOOLTIP_CONTENT} placement="top">
          <Text
            size="small"
            color={isDirty ? 'subtle' : 'primary'}
            className={classes.subtemplate}
          >
            {startCase(stName)} <NewTab />
          </Text>
        </Tooltip>
      ) : (
        <a href={url} target="_blank">
          <Text
            size="small"
            color={isDirty ? 'subtle' : 'primary'}
            className={classes.subtemplate}
          >
            {startCase(stName)} <NewTab />
          </Text>
        </a>
      )}
    </NodeViewWrapper>
  )
}

export default StComponent
